<template>
    <section class="line" id="myLineEcharts">
    </section>
</template>

<style lang="scss" scoped="scoped">
    .line {
        width: 100%;
        height: 100%;
        display: inline-flex;
    }
</style>

<script>

    export default {
        components: {

        },
        data () {
            return {
                myChart: {}
            }
        },
        props: ["resultData"],
        computed: {
            getOption () {
                let opt = {
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        backgroundColor: 'rgba(255, 255, 255, .92)',
                        textStyle: {
                            color: '#142C3D'
                        },
                        extraCssText: 'box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);',
                        axisPointer: {
                        	lineStyle: {
                        		color: '#26ABFF',
                                width: 2
                            }
                        },
                        formatter: (params) => {
                        	let str = this.resultData.dateArr[params[0].dataIndex] + '<br>' + params[0].marker + params[0].seriesName + ':' + params[0].value;
                        	if (params.length === 2) {
                        		str += '<br>' + this.resultData.dateCompareArr[params[1].dataIndex] + '<br>' + params[1].marker + params[1].seriesName + ':' + params[1].value;
                            }
                        	return str;
                        }
                    },
                    grid: {
                        left: '2%',
                        right: '3%',
                        top: '2%',
                        bottom: '2%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
	                    boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: '#E9EEF0'
                            }
                        },
                        axisLabel: {
                            color: '#6E808B'
                        },
                        data: this.formatDays(this.resultData.dateArr)
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#E9EEF0'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#6E808B'
                        }
                    },
                    series: [
                        {
                            name: this.resultData.currentTypeName,
                            type: 'line',
                            data: this.formatDatas(this.resultData.dataArr),
                            smooth: true,
	                        connectNulls: true,
                            itemStyle: {
                                normal: {
                                    color: '#26ABFF'
                                }
                            },
                            areaStyle: {
                            	normal: {
                            		color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {
                                        	offset: 0,
                                            color: 'rgba(11, 147, 255, .2)'
                                        },
                                        {
                                        	offset: 1,
                                            color: 'rgba(72, 199, 255, 0)'
                                        }
                                    ])
                                }
                            }
                        }
                    ]
                };
                if (this.resultData && this.resultData.dateCompareArr.length !== 0 && this.resultData.dataCompareArr.length !== 0) {
                	opt.series.push({
		                name: this.resultData.currentTypeName,
		                type: 'line',
		                data: this.formatDatas(this.resultData.dataCompareArr),
		                smooth: true,
		                connectNulls: true,
		                itemStyle: {
			                normal: {
				                color: '#1bd380'
			                }
		                },
		                areaStyle: {
			                normal: {
				                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
					                {
						                offset: 0,
						                color: 'rgba(76, 238, 166, .2)'
					                },
					                {
						                offset: 1,
						                color: 'rgba(45, 212, 137, 0)'
					                }
				                ])
			                }
		                }
                    })
                }
                return opt;
            }
        },
	    watch: {
		    resultData: {
		    	handler: function () {
		    		this.changeEcharts();
                },
                deep: true
            }
	    },
        methods: {
            setEcharts () {
                let dom = document.getElementById('myLineEcharts');
                this.myChart = echarts.init(dom);
                this.myChart.setOption(this.getOption, true);
            },
            changeEcharts () {
                this.myChart.setOption(this.getOption, true);
            },
            formatDays (arr) {
            	if (this.resultData && this.resultData.dateCompareArr.length !== 0 && this.resultData.dataCompareArr.length !== 0) {
		            let days = [];
		            arr.forEach((item, index) => {
			            days.push('第' + (index + 1) + '天');
		            });
		            return days;
                } else {
            		return arr;
                }
            },
	        formatDatas (arr) {
            	let datas = arr.map((item) => {
            		return (!item || item === null || item === '') ? 0 : item;
                })
                return datas;
	        }
        },
        mounted () {
            this.setEcharts();
        }
    }
</script>



// WEBPACK FOOTER //
// Line.vue?4dcc1fdd